import React, {isValidElement, ReactNode} from "react";
import s from "./Example.module.scss";
import reactElementToJSXString from "react-element-to-jsx-string";

export interface IGenericExampleProps {
  title?: string;
  children?: ReactNode;
  renderChildren?: boolean; // If false, children will not be rendered. Useful for when you just want to convert code to a string for a documentation example.
}

export function Example({title, children, renderChildren = true}: IGenericExampleProps) {
  let jsxString = '';
  if (Array.isArray(children)) {
    children.forEach(node => {
      if (isValidElement(node)) {
        jsxString += reactElementToJSXString(node, {
          showFunctions: true,
        });
        jsxString += "\n";
      } else {
        throw new Error("Children must be valid React elements in order to get a JSX string for them.");
      }
    });
  } else if (isValidElement(children)) {
    /**
     * If false, functions are shown as "function noRefCheck() {}". Who wants that?
     * @see https://github.com/algolia/react-element-to-jsx-string/tree/v15.0.0?tab=readme-ov-file#api
     */
    jsxString = reactElementToJSXString(children, {
      showFunctions: true,
    });
  } else if (children) {
    throw new Error("Single ReactNodes must be valid React elements in order to get a JSX string for them.");
  }

  return <div className={s.container}>
    <header>
      EXAMPLE
      { title ? `: ${title}` : null }
    </header>
    {
      renderChildren
        ? <div className={s.uiContainer}>
          {children}
        </div>
        : null
    }
    <pre className={s.code}>
      <code>
        {jsxString}
      </code>
    </pre>
  </div>;
}
